module.exports = __webpack_public_path__ + "df12b37123e67d78ea9a7f47f7b09ed2.png";